import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { MedicalServicesPageState, MedicalServicesPageUnloadState } from '../../../redux/states/MedicalServicesState';

// stores
import * as MedicalServiceStore from '../../../redux/middleware/MedicalServicesMiddleware';
import { AvailableMedicalService } from '../../../models/Entities/MedicalServices/AvailableMedicalService';

//#region Props

interface IProps {
  editEvent?: (service: AvailableMedicalService) => void;
  /** "Agregar servicio" en la barra del listado (lo abre la página). */
  onAdd?: () => void;
}

interface ConnectedProps {
  /** Página recibida del servidor (búsqueda + paginado). */
  Page: MedicalServicesPageState;
  isDeleting: boolean;
  isDeletedSuccessfully: boolean | undefined;
  failOnDeleting: boolean;
  isChangingStatus: boolean;
  failOnChangingStatus: boolean;
  isSaving: boolean;
  savedSuccessfully: boolean | undefined;
  addedSuccessfully: boolean | undefined;
  error: ErrorType | undefined;
}

interface MedicalServicesDispatchProps {
  GetMedicalServicesPage: typeof MedicalServiceStore.actionCreators.GetMedicalServicesPage;
  ChangeMedicalServiceStatus: typeof MedicalServiceStore.actionCreators.ChangeMedicalServiceStatus;
  DeleteMedicalService: typeof MedicalServiceStore.actionCreators.DeleteMedicalService;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  Page: state.MedicalServices?.page ?? MedicalServicesPageUnloadState,
  isDeleting: state.MedicalServices?.isDeletingOne,
  isDeletedSuccessfully: state.MedicalServices?.successDeletingOne,
  failOnDeleting: state.MedicalServices?.failOnDeletingOne,
  isChangingStatus: state.MedicalServices?.isChangingStatus,
  failOnChangingStatus: state.MedicalServices?.failOnChangingStatus,
  isSaving: state.MedicalServices?.isUpdatingOne || state.MedicalServices?.isAddingNewOne,
  savedSuccessfully: state.MedicalServices?.successUpdatingOne,
  addedSuccessfully: state.MedicalServices?.successAddingNewOne,
  error: state.MedicalServices?.error
});

export const mapDispatchToProps = {
  ...MedicalServiceStore.actionCreators
};

//#endregion Props
